export const workflowChangeStatusAlertMessages = {
	Draft: {
		Question: `<div class="mt-4">
          Once you send this document for review, it will require approval from a user with review permission before it can be published.
          <br /><br />
          <strong>Do you want to continue?</strong>
        </div>`,
		Success: "All set! Your document is waiting for approval.",
	},
  Rejected: {
    Question: `
      <div class="mt-4">
        Once you reject this document, it will return to Draft status and won't be published.
        <br /><br />
        <strong>Do you want to continue?</strong>
      </div>
    `,
    Success: "The document has been rejected and moved back to Draft."
  },

  Approved: {
    Question: `
      <div class="mt-4">
        Once you approve this document, it will move to Approved status and can be published.
        <br /><br />
        <strong>Do you want to continue?</strong>
      </div>
    `,
    Success: "All set! Your document is ready to be published."
  },

  Publish: {
    Question: `
      <div class="mt-4">
        Once you publish this document, it will be available for download in PDF and DOCX.
        <br /><br />
        <strong>Do you want to continue?</strong>
      </div>
    `,
    Success: "All set! Your document is published."
  },

  Obsolete: {
    Question: `
      <div class="mt-4">
        Once you obsolete this document, it will no longer be available for active use, but will remain in the system history.
        <br /><br />
        <strong>Do you want to continue?</strong>
      </div>
    `,
    Success: "All set! Your document is now obsolete."
  }
};